"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Font = void 0;
/**
 *
 *
 */
class Font {
    static PLAIN = 0;
    static BOLD = 1;
    static ITALIC = 2;
    _size = 10;
    _text = "";
    _type = 0;
    constructor(s, type, size) {
        this._text = s;
        this._type = type;
        this._size = size;
        return;
    }
    getSize() {
        return this._size;
    }
    getName() {
        return this._text;
    }
    getType() {
        return this._type;
    }
    isBold() {
        return (this._type === Font.BOLD);
    }
    getTypeString() {
        let ret;
        switch (this._type) {
            case Font.BOLD:
                {
                    ret = "bold";
                    break;
                }
            case Font.ITALIC:
                {
                    ret = "italic";
                    break;
                }
            default:
                {
                    ret = "normal";
                    break;
                }
        }
        return ret;
    }
    static getTypeString(type) {
        let ret;
        switch (type) {
            case Font.BOLD:
                {
                    ret = "bold";
                    break;
                }
            /*case Font.ITALIC:
            {
                ret = "italic";
                break;
            }*/
            default:
                {
                    ret = "normal";
                    break;
                }
        }
        return ret;
    }
    static getTypeInt(type) {
        let ret = Font.PLAIN;
        switch (type) {
            case "bold":
                {
                    ret = Font.BOLD;
                    break;
                }
            case "italic":
                {
                    ret = Font.ITALIC;
                    break;
                }
            default:
                {
                    ret = Font.PLAIN;
                    break;
                }
        }
        return ret;
    }
    toString() {
        let font = this.getTypeString() + " " + this._size + "px " + this._text;
        return font;
    }
}
exports.Font = Font;
//# sourceMappingURL=Font.js.map